__turbopack_context__.v({
  "container": "Breadcrumbs-module-scss-module__8yLkQq__container",
  "lastItem": "Breadcrumbs-module-scss-module__8yLkQq__lastItem",
  "list": "Breadcrumbs-module-scss-module__8yLkQq__list",
  "listItem": "Breadcrumbs-module-scss-module__8yLkQq__listItem",
});
